import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import styled from "styled-components";

const FormGroup = styled.div`
  ${tw`mb-4`}
`;

const formControlStyle = `
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

export const formElement = (WrappedComponent) => {
  const StyledWrapped = styled(WrappedComponent)`
    ${formControlStyle}
  `;

  return class extends React.Component {
    static propTypes = {
      id: PropTypes.any,
      title: PropTypes.string,
      name: PropTypes.string,
      className: PropTypes.string,
      children: PropTypes.any
    };

    render() {
      return (
        <FormGroup>
          <label htmlFor={this.props.id}>{this.props.title}</label>
          <StyledWrapped
            {...this.props}
            id={this.props.id}
            name={this.props.name}
            className={this.props.className}
          >
            {this.props.children}
          </StyledWrapped>
        </FormGroup>
      );
    }
  };
};
